const config = {
	publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY
}

export default config
